import { faEnvelopeOpenText } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { FontAwesomeIcon } from 'atoms/icons';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineM, Text16, Title5 } from 'atoms/typography';
import { Bold } from 'atoms/typography/Bold';
import Dialog from 'components/dialog';
import useScreenSize from 'hooks/device/useScreenSize';
import { glossary } from 'lib/glossary';

const messages = defineMessages({
  title: {
    id: 'Settings.updateEmail.dialog.title',
    defaultMessage: 'Change email',
  },
  subtitle: {
    id: 'Settings.updateEmail.dialog.subtitle',
    defaultMessage: 'Verify your new email adress',
  },
  description: {
    id: 'Settings.updateEmail.dialog.description',
    defaultMessage:
      'We’ll need to verify your new email adress <b>{email}</b> in order to change it',
  },
});

const Content = styled(Vertical).attrs({ gap: 2 })`
  text-align: center;
  padding: var(--triple-unit);
`;

type Props = {
  email: string;
  onClose: () => void;
};

export const UpdateEmailDialog = ({ email, onClose }: Props) => {
  const { up: isTablet } = useScreenSize('tablet');

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open
      onClose={onClose}
      fullScreen={!isTablet}
      title={
        <HeadlineM as="h2" className="text-center">
          <FormattedMessage {...messages.title} />
        </HeadlineM>
      }
    >
      <Content>
        <FontAwesomeIcon
          icon={faEnvelopeOpenText}
          size="5x"
          color="var(--c-neutral-1000)"
        />
        <Title5>
          <FormattedMessage {...messages.subtitle} />
        </Title5>
        <Text16 color="var(--c-neutral-600)">
          <FormattedMessage
            {...messages.description}
            values={{
              b: Bold,
              email,
            }}
          />
        </Text16>
        <Button onClick={onClose} color="quaternary" size="medium" fullWidth>
          <FormattedMessage {...glossary.ok} />
        </Button>
      </Content>
    </Dialog>
  );
};
